import { DonutChartData, DonutLegendItem } from '../../../../shared/components/DonutCharts'

import { filterEmptyDonutCategories } from '../../../../shared/components/DonutCharts/hooks/filterEmptyCategories'
import { useGetActivityByFunctionQuery } from '../../../../shared/queries/metrics/useGetActivityByFunctionQuery'
import { useMemo } from 'react'
import useActivityStatuses from '../../../../shared/hooks/useActivityStatuses'
import { Activity } from '../../../../shared/queries/useGetActivitiesQuery'
import { COLORS } from '../../../../style/colors'
import { getActivityStatusDetailsIcon } from '../../../../shared/hooks/useActivityStatuses/useActivityStatuses.helpers'

const useActivityMetrics = () => {
    const getActivityByFunctionQuery = useGetActivityByFunctionQuery()

    const { activityStatusDetails } = useActivityStatuses()

    const legend = useMemo(
        (): DonutLegendItem[] => [
            ...activityStatusDetails.map((statusDetails) => ({
                id: statusDetails.id,
                label: statusDetails.name,
                color: statusDetails.color,
                icon: statusDetails.icon,
            })),
            {
                id: 'Uncategorized',
                label: 'No Status',
                color: COLORS.granite,
                icon: getActivityStatusDetailsIcon({ shape: 'circle', color: COLORS.granite }),
            },
        ],
        [activityStatusDetails]
    )

    const data = useMemo((): DonutChartData<Activity>[] => {
        if (!getActivityByFunctionQuery.data) {
            return []
        }

        return getActivityByFunctionQuery.data.map(({ grouping: title, items: statuses }) => {
            const values: { count: number; items: Activity[]; label: string }[] = legend.map((legendItem) => {
                const items = statuses[legendItem.id] || []
                return { items, count: items.length, label: legendItem.label }
            })
            return { title, values }
        })
    }, [getActivityByFunctionQuery.data])

    const { filteredLegend, filteredData } = useMemo(() => filterEmptyDonutCategories(legend, data), [data])

    return { legend: filteredLegend, data: filteredData, isLoading: getActivityByFunctionQuery.isLoading }
}

export default useActivityMetrics
